import { render } from "./BaseSettings.vue?vue&type=template&id=53435d29&scoped=true"
import script from "./BaseSettings.vue?vue&type=script&lang=js"
export * from "./BaseSettings.vue?vue&type=script&lang=js"

import "./BaseSettings.vue?vue&type=style&index=0&id=53435d29&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53435d29"]])

export default __exports__